import { AcuerdoComercial } from '@/models/AcuerdoComercial';

/**
 * Interface del estado de las administraciones cacheadas
 */
export interface CAAcuerdosLibresCacheState {
  cache_acuerdos_libres: AcuerdoComercial[];
}

export const CACHE_ACUERDOS_LIBRES_MUTATION_AGREGAR: string = 'agregarAcuerdoLibre';
export const CACHE_ACUERDOS_LIBRES_MUTATION_ELIMINAR: string = 'eliminarAcuerdoLibre';
export const CACHE_ACUERDOS_LIBRES_MUTATION_MODIFICAR: string = 'modificarAcuerdoLibre';
export const CACHE_ACUERDOS_LIBRES_MUTATION_OBTENER: string = 'obtenerAcuerdoLibre';
export const CACHE_ACUERDOS_LIBRES_MUTATION_OBTENER_TODOS: string = 'obtenerTodosLosAcuerdosLibres';
export const CACHE_ACUERDOS_LIBRES_MUTATION_REEMPLAZAR_TODOS: string = 'reemplazarTodosLosAcuerdosLibres';